var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.inline
      ? _c("textarea", { attrs: { id: _vm.tinymceId } })
      : _c("div", { attrs: { id: _vm.tinymceId + "inline" } }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }